export const environment = {
  namespace: 'develop',
  production: false,
  cookieBaseUrl: 'reuse.me',
  serverBaseUrl: 'https://develop.app.reuse.me',
  apiBaseUrl: 'https://develop.app.reuse.me/api/admin/v1/',
  cookieKey: "reuseme-adminpanel-develop",
  applicationName: 'reuse.me DEV'
};
